import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button } from '@material-ui/core'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as FacebookActions from '../../../actions/facebook'
import './styles.css'

class FacebookLoginButton extends Component {
  static get propTypes () {
    return { actions: PropTypes.object.isRequired }
  }

  constructor (props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }

  render () {
    return (
      <Button 
        variant='contained'
        color='primary' 
        onClick={this.handleClick}>Facebook</Button>
    )
  }

  handleClick () {
    const { actions: { getFacebookLoginStatus } } = this.props
    window.FB.login((response) => {
      getFacebookLoginStatus()
    })
  }
}

const mapDispatch = (dispatch) => {
  return {
    actions: bindActionCreators(FacebookActions, dispatch)
  }
}

export default connect(null, mapDispatch)(FacebookLoginButton)
